/**
 * Utilitário para gerenciar funcionalidades de áudio da frase
 * @param {string} phrase - Frase para reproduzir
 * @returns {Object} Funções para controlar áudio
 */
export const createPhraseAudio = (phrase) => {
  const playFullPhrase = () => {
    if (!phrase) return;

    const utterance = new SpeechSynthesisUtterance(phrase);
    utterance.lang = 'en-US';
    utterance.rate = 0.7; // Mais lento para aprendizado
    utterance.pitch = 1.0;
    utterance.volume = 1.0;
    speechSynthesis.speak(utterance);
  };

  return {
    playFullPhrase
  };
};
